export default "__VITE_ASSET__BpPub_7Z__"